export default __webpack_public_path__ + "static/media/rewards-coins.aa7a2d5a.png";